
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface StatCardProps {
  title: string;
  value: number | string;
  subtitle?: string;
  progress?: number;
}

export const StatCard: React.FC<StatCardProps> = ({ 
  title, 
  value, 
  subtitle, 
  progress 
}) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{value}</div>
        {subtitle && (
          <p className="text-xs text-muted-foreground">
            {subtitle}
          </p>
        )}
        {progress !== undefined && (
          <Progress 
            value={progress} 
            className="h-2 mt-2"
          />
        )}
      </CardContent>
    </Card>
  );
};

interface StatsCardsProps {
  stats: any;
}

export const StatsCards: React.FC<StatsCardsProps> = ({ stats }) => {
  if (!stats) return null;
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <StatCard 
        title="Total Training Samples" 
        value={stats?.totalSamples || 0} 
        subtitle={`${stats?.last30DaysGrowth || 0} new in last 30 days`}
      />
      
      <StatCard 
        title="Confirmed Accurate" 
        value={stats?.distribution?.accurate || 0}
        progress={stats?.totalSamples ? (stats.distribution.accurate / stats.totalSamples) * 100 : 0}
      />
      
      <StatCard 
        title="False Positives" 
        value={stats?.distribution?.false_positive || 0}
        progress={stats?.totalSamples ? (stats.distribution.false_positive / stats.totalSamples) * 100 : 0}
      />
      
      <StatCard 
        title="False Negatives" 
        value={stats?.distribution?.false_negative || 0}
        progress={stats?.totalSamples ? (stats.distribution.false_negative / stats.totalSamples) * 100 : 0}
      />
    </div>
  );
};
